// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-form .table-form-content[data-v-6b658935] {\n  display: grid;\n  grid-template-columns: repeat(var(--col, 4), 1fr);\n}\n.table-form .table-form-item[data-v-6b658935] {\n  padding-bottom: 20px;\n  padding-right: 20px;\n}\n.table-form .table-form-item.btn-group[data-v-6b658935] {\n  grid-column: auto/-1;\n  text-align: right;\n}\n.table-form .table-form-item .el-form-item[data-v-6b658935] {\n  margin: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
